import {
  setSnackbar,
  stopRequestComp,
  startRequestComp
} from "redux/actions/search/searchActions";
import { BRANDS_METERS_TYPES } from "redux/reducers/buildings/brands/brandsMetersTypes";
import { api_put, api_post, api_get, PROYECT } from "services/api";

const {
  SET_BRANDS_METERS_NEW,
  MODELS_BY_BRANDS_METERS,
  NEW_BRAND_MODEL,
  UPSERT_BRAND_MODEL,
  EDIT_BRAND_MODEL,
  CLEAR_BRAND_MODEL
} = BRANDS_METERS_TYPES;

const urlModels = `${process.env.REACT_APP_URL}${PROYECT}/buildings/models`;

export function clearBrands() {
  return {
    type: CLEAR_BRAND_MODEL
  };
}

export const getBrandsMeters = () => async dispatch => {
  dispatch(startRequestComp("getBrandsMeters"));
  try {
    const brands = await api_get(urlModels);

    dispatch({
      type: SET_BRANDS_METERS_NEW,
      payload: { brands }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("getBrandsMeters"));
};

export const getModelsByBrand = id => {
  return dispatch => {
    dispatch({
      type: MODELS_BY_BRANDS_METERS,
      payload: id
    });
  };
};

export const fetchNewBrandModel = body => async dispatch => {
  dispatch(startRequestComp("fetchNewBrandModel"));
  try {
    const response = await api_post(urlModels, body);
    dispatch({
      type: UPSERT_BRAND_MODEL,
      payload: response
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("fetchNewBrandModel"));
};

export const fetchEditBrandModel = (id, body) => async dispatch => {
  dispatch(startRequestComp("fetchEditBrandModel"));
  try {
    const response = await api_put(`${urlModels}/${id}`, body);
    dispatch({
      type: UPSERT_BRAND_MODEL,
      payload: response
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("fetchEditBrandModel"));
};

export function newBrandModel() {
  return {
    type: NEW_BRAND_MODEL
  };
}

export function editBrandModel(id) {
  return {
    type: EDIT_BRAND_MODEL,
    payload: id
  };
}
